<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <BreadCrumbs
          v-model="deviceGroupId"
          :modelId="modelId"
          :serialNo="serialNo"
          @click_breadCrumbs="selectedGroupChange"
          @click_breadCrumbsDevice="selectedDeviceChange"
        />
        <v-divider />
      </v-col>
    </v-row>
    <v-row justify="center" align-content="center">
      <v-col cols="12">
        <v-card outlined>
          <!-- タイトル -->
          <v-card-title>
            <v-row dense>
              <v-col cols="12">
                <custom-icon type="machineInfo" :size="30" :colors="['#162A4F']" class="mr-3"> </custom-icon>
                <span :style="{ display: 'inline-block', height: 100 + '%', 'vertical-align': 'top' }">
                  {{ machine }}
                </span>
              </v-col>
              <v-col cols="12">
                <v-divider></v-divider>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text class="mt-2">
            <!-- お客様管理号機 -->
            <v-row>
              <v-col class="ml-5 body-1" cols="4" xl="1" lg="2" md="3" sm="4">
                {{ $t('customerSMachineNo') }}
              </v-col>
              <v-col class="body-1" cols="6" xl="2" lg="2" md="4" sm="5">
                {{ customer }}
              </v-col>
            </v-row>
            <!-- テーブル -->
            <v-row>
              <v-col class="ml-5">
                <v-data-table
                  class="v-data-table-outlined"
                  :headers="[
                    { text: $t('category'), align: 'start', value: 'fservicecd' },
                    { text: $t('workContents'), align: 'start', value: 'taskType' },
                    { text: $t('completionDate'), align: 'start', value: 'finishDate' },
                    { text: $t('runningHour'), align: 'end', value: 'fkadotm' },
                    // { text: 'PDF', align: 'center', value: 'attachmentFile', class: 'v-data-table-background-white v-data-table-border-left', cellClass: 'v-data-table-border-left' }
                  ]"
                  :items="items"
                  :footer-props="{ 'items-per-page-text': $t('display') }"
                >
                  <template v-slot:[`item.attachmentFile`]="{ item }">
                    <v-icon color="red" v-if="item.attachmentFile"> mdi-file-pdf-outline </v-icon>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import CustomIcon from '../components/CustomIcon.vue';
  import BreadCrumbs from '../components/BreadCrumbs.vue';

  export default {
    title() {
      return this.$t(this.$route.meta.title);
    },
    name: 'MaintenanceHistory',
    components: {
      CustomIcon,
      BreadCrumbs,
    },
    data: () => ({
      localeId: 2,
      machine: '',
      customer: '',
      items: [],
      deviceGroupId: '',
    }),
    async created() {
      // URLから値を取得
      this.modelId = this.$route.params.model_id;
      this.serialNo = this.$route.params.serial_no;

      this.$store.commit('loading/start_loading');

      // ぱんくずリスト設定
      const userDeviceAuthorities = await this.apiRequest('/v1/master-info/userDeviceAuthorities', 'GET', {
        model_id: this.modelId,
        serial_no: this.serialNo,
      });
      if (userDeviceAuthorities === null) {
        this.$store.commit('loading/end_loading');
        return;
      }
      this.deviceGroupId = userDeviceAuthorities[0].device_group_id;
      console.log(this.deviceGroupId);

      // デバイス情報取得
      const devices = await this.apiRequest('/v1/master-info/devices', 'GET', {
        model_id: this.modelId,
        serial_no: this.serialNo,
      });
      if (devices === null) {
        this.$store.commit('loading/end_loading');
        return;
      }

      // ロケールを変更
      this.setLocale();

      this.machine = devices[0][`name_locale${this.localeId}`];
      this.customer = devices[0].optional_info_2;

      // Smartpassのサービス実績情報を取得
      const reports = await this.azureRequest('/api/getSmartpassReports', 'GET', { equipmentNos: this.machine });
      if (reports) {
        for (const report of reports) {
          // 試運転、年次点検、OH、保守点検のみ
          if (['1', '3', '4', '9'].includes(report.fservicecd)) {
            this.items.push({
              fservicecd: this.getFservicecdName(report.fservicecd),
              taskType: this.getTasktypeName(report.taskType),
              finishDate: report.finishDate,
              fkadotm: report.fkadotm,
            });
          }
        }
      }

      this.$store.commit('loading/end_loading');
    },
    methods: {
      // ぱんくずリストクリック
      selectedGroupChange(group) {
        this.$router.push({
          name: group.children.length > 0 ? 'HomeAdmin' : 'HomeConsumer',
          params: { device_group_id: group.device_group_id },
        });
      },
      selectedDeviceChange(device) {
        this.$router.push({
          name: 'CompressorInfo',
          params: { model_id: device.model_id, serial_no: device.serial_no },
        });
      },
      // サービス業績区分
      getFservicecdName(code) {
        switch (code) {
          case '1':
            return this.$t('commissioning');
          case '2':
            return this.$t('patrol');
          case '3':
            return this.$t('3000Hr_6000Hr_12000HrMaintenance');
          case '4':
            return this.$t('overhaul');
          case '5':
            return this.$t('warrantyClaimRelated');
          case '6':
            return this.$t('preventiveMaintenance');
          case '7':
            return this.$t('emergencyCallCheckup');
          case '8':
            return this.$t('partsChangeOthersEtc');
          case '9':
            return this.$t('patrolServiceCleanup');
        }
      },
      // 作業内容
      getTasktypeName(code) {
        switch (code) {
          case '99':
            return '--';
          case '101':
            return this.$t('commissioning');
          case '201':
            return this.$t('patrol');
          case '301':
            return this.$t('2000Hr');
          case '302':
            return this.$t('3000Hr');
          case '303':
            return this.$t('4000Hr');
          case '304':
            return this.$t('6000Hr');
          case '305':
            return this.$t('8000Hr');
          case '306':
            return this.$t('12000Hr');
          case '307':
            return this.$t('16000Hr');
          case '308':
            return this.$t('24000Hr');
          case '309':
            return this.$t('36000Hr');
          case '310':
            return this.$t('halfYearMaintenance');
          case '311':
            return this.$t('1YearMaintenance');
          case '312':
            return this.$t('2YearMaintenance');
          case '313':
            return this.$t('3YearMaintenance');
          case '314':
            return this.$t('4YearMaintenance');
          case '315':
            return this.$t('6YearMaintenance');
          case '316':
            return this.$t('4YearAnd_6YearMaintenance');
          case '317':
            return this.$t('8YearMaintenance');
          case '318':
            return this.$t('18000Hr');
          case '399':
            return this.$t('annualMaintenance');
          case '401':
            return this.$t('claim');
          case '402':
            return this.$t('preventiveMaintenance');
          case '501':
            return this.$t('irregularMaintenance');
          case '502':
            return this.$t('others');
          case '503':
            return this.$t('patrolService');
          case '901':
            return this.$t('oh_2ndStage');
          case '902':
            return this.$t('oh_1stStage');
          case '903':
            return this.$t('oh_1stAnd_2ndStage');
          case '904':
            return this.$t('oh');
          case '905':
            return this.$t('oh_1stAnd_2ndStage_6YearMaintenance');
          case '906':
            return this.$t('oh_36000Hr');
          case '907':
            return this.$t('oh_6YearMaintenance');
          case '908':
            return this.$t('ohFourYears');
          case '909':
            return this.$t('ohEightYears');
          case '999':
            return this.$t('regularMaintenance');
        }
      },
      setLocale() {
        switch (this.$i18n.locale) {
          case 'en':
            this.localeId = 1;
            break;
          case 'ja':
            this.localeId = 2;
            break;
          case 'zh':
            this.localeId = 3;
            break;
        }
      },
    },
  };
</script>
